import { render } from "./AirbitDocsPage.vue?vue&type=template&id=f8afd078&scoped=true"
import script from "./AirbitDocsPage.vue?vue&type=script&lang=js"
export * from "./AirbitDocsPage.vue?vue&type=script&lang=js"

import "./AirbitDocsPage.vue?vue&type=style&index=0&id=f8afd078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8afd078"]])

export default __exports__